/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Continue_With_GoogleInputs */

const en_login_continue_with_google = /** @type {(inputs: Login_Continue_With_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Google`)
};

const fr_login_continue_with_google = /** @type {(inputs: Login_Continue_With_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer avec Google`)
};

const de_login_continue_with_google = /** @type {(inputs: Login_Continue_With_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Google fortfahren`)
};

const it_login_continue_with_google = /** @type {(inputs: Login_Continue_With_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua con Google`)
};

const ru_login_continue_with_google = /** @type {(inputs: Login_Continue_With_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить с Google`)
};

const es_login_continue_with_google = /** @type {(inputs: Login_Continue_With_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar con Google`)
};

const zh_cn2_login_continue_with_google = /** @type {(inputs: Login_Continue_With_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续使用 Google`)
};

const ja_login_continue_with_google = /** @type {(inputs: Login_Continue_With_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Googleで続行`)
};

const hi_login_continue_with_google = /** @type {(inputs: Login_Continue_With_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google के साथ जारी रखें`)
};

const pt_pt2_login_continue_with_google = /** @type {(inputs: Login_Continue_With_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar com o Google`)
};

/**
* | output |
* | --- |
* | "Continue with Google" |
*
* @param {Login_Continue_With_GoogleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_continue_with_google = /** @type {((inputs?: Login_Continue_With_GoogleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Continue_With_GoogleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_continue_with_google(inputs)
	if (locale === "de") return de_login_continue_with_google(inputs)
	if (locale === "it") return it_login_continue_with_google(inputs)
	if (locale === "ru") return ru_login_continue_with_google(inputs)
	if (locale === "es") return es_login_continue_with_google(inputs)
	if (locale === "zh-CN") return zh_cn2_login_continue_with_google(inputs)
	if (locale === "ja") return ja_login_continue_with_google(inputs)
	if (locale === "hi") return hi_login_continue_with_google(inputs)
	if (locale === "pt-PT") return pt_pt2_login_continue_with_google(inputs)
	return en_login_continue_with_google(inputs)
});